import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createEntityMutations } from '../../../shared/api/createEntityMutations.js';
import { useCurrentScope } from '../../../shared/scope/useCurrentScope.js';
import {
  createProject,
  deleteProject,
  setProjectMembers,
  updateProject,
  type CreateProjectInput,
  type ProjectItem,
  type UpdateProjectInput,
} from '../api/projects.client.js';

const projectMutations = createEntityMutations<ProjectItem, CreateProjectInput, UpdateProjectInput>(
  {
    key: 'projects',
    create: createProject,
    update: updateProject,
    remove: deleteProject,
  },
);

export const useCreateProjectMutation = projectMutations.useCreate;
export const useUpdateProjectMutation = projectMutations.useUpdate;
export const useDeleteProjectMutation = projectMutations.useDelete;

/** Замена состава участников: отдельная мутация, инвалидирует карточку и списки. */
export function useSetProjectMembersMutation() {
  const queryClient = useQueryClient();
  const scope = useCurrentScope();
  const workspaceId = scope?.workspaceId ?? 'anonymous';
  return useMutation<ProjectItem, Error, { id: string; memberIds: string[] }>({
    mutationFn: ({ id, memberIds }) => setProjectMembers(id, memberIds),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['projects', workspaceId] });
      void queryClient.invalidateQueries({ queryKey: ['activities', workspaceId] });
    },
  });
}
